<template>
<div>
    <div v-if="btnNextStep">
      <b-row class="pt-4">
        <b-col>
          <h3>{{$t('label.yourSignature')}}</h3>
        </b-col>
      </b-row>
      <b-img :src="signature" fluid alt="Responsive image" width="500" height="500"></b-img>
    </div>

    <div v-else>
      <b-row class="pt-4">
        <b-col>
          <h3>{{$t('label.signatureBox')}}</h3>
          <hr />
          <div> {{$t('info.declaration')}} </div>
          <hr />
          <div> * {{$t('info.optIn')}}</div>
        </b-col>
      </b-row>
      <hr />
      <b-row class="pt-4">
        <b-col>
          <VueSignaturePad
              id="signature"
              width="100%"
              height="500px"
              ref="signaturePad"
            />
        </b-col>
      </b-row>

      <div> {{$t('info.prp')}} </div>

      <b-row class="pt-4">
        <b-col>
        <b-button-group>
          <b-button variant="success" @click="save()">Save</b-button>
          <b-button variant="danger" @click="undo()">Undo</b-button>
        </b-button-group>
        </b-col>
      </b-row>

    </div>

    <!-- spinner -->
    <div v-if="spinner" class="text-center pt-2">
      <b-spinner style="width: 3rem; height: 3rem;" variant="success" label="Spinning" disabled="labelStatus"></b-spinner>
    </div>

    <div v-if="errorSignature" class="pt-4">
    <b-alert show variant="warning">
        <p>{{$t('info.errorSignature')}}</p>
    </b-alert>
    </div>

    <!-- error -->
    <div v-if="error" class="pt-4">
        <b-alert sm="6" show variant="danger">
            <p>{{ error }}</p>
        </b-alert>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
mixins: [],
props: ["btnNextStep", "from"],
data() { return {
  error: "",
  errorSignature: false,
  spinner: false,   
}},
computed: {
    url: function () {
    let urls = this.$store.getters.getUrlsList;
    return urls[process.env.VUE_APP_WHERE].json;
  },
  signature: function () {
    let processData = this.$store.getters.getProcessData;
    if (this.from === "endorser") {
      processData = this.$store.getters.getEndorserData;
    }
    let signature = "";
    let step2data = processData[2];
    if (step2data && step2data.hasOwnProperty("signature")) {
      signature = step2data.signature;
    }
    return signature;
  }
},
methods:{
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      this.errorSignature = false;
      this.error = "";
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (isEmpty) {
        this.errorSignature = true;
      }
      else {
        this.spinner = true;
        let signature = {signature: data};
        let request = "getSignature";
        if (this.from === 'endorser') {
          request = "getEndorserSignature";
        }
        axios.post(this.url, {request: request, jsonData: JSON.stringify(signature)  }, { headers: {'Content-Type': 'application/json'}})
                .then((response)  => {
                    this.spinner = false;

                    if (response.data.status === 0) {
                        window.location.reload(true);
                    }
                    else {
                        this.error = this.$t('info.errorgeneric');
                    }
                    
                })
                .catch(()  => {
                    this.error = this.$t('info.errorgeneric');
                    this.spinner = false;
                });
      }
    }
},
components: {}
}
</script>